import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import { ImageViewer } from "../";

const ItemList = ({ items, swiper = false, viewer = false }) => {
  const [toggler, setToggler] = useState(false);
  const [imgs, setImgs] = useState(null);

  const t_marks = (itm) => {
    let inter = 0;
    let arr = ["n", "n", "n", "n", "n"];
    if (`${itm}`.split(".").length === 2) {
      inter = parseInt(`${itm}`.split(".")[0]);

      for (let i = 0; i < parseInt(`${itm}`.split(".")[0]); i++) {
        if (inter < 5) {
          arr[i] = "y";
          arr[i + 1] = "h";
        }
      }
    } else {
      inter = parseInt(`${itm}`.split(".")[0]);
      for (let i = 0; i < parseInt(`${itm}`.split(".")[0]); i++) {
        arr[i] = "y";
      }
    }
    return arr;
  };

  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  function onAutoplayTimeLeft(swiper) {
    if (swiper && swiper.$el) {
      const autoplayEl = swiper.$el[0].querySelector(
        ".swiper-autoplay-time-left"
      );

      if (autoplayEl) {
        // Your logic to update the style of autoplayEl
        autoplayEl.style.width = `${
          (swiper.autoplay.remainingTime / swiper.params.autoplay.delay) * 100
        }%`;
      }
    }
  }

  return swiper ? (
    <Swiper
      slidesPerView={3}
      spaceBetween={30}
      pagination={{
        clickable: true,
      }}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      onAutoplay={onAutoplayTimeLeft}
      modules={[Pagination, Autoplay, Navigation]}
      className="mySwiper"
    >
      {viewer ? <ImageViewer sources={imgs} toggler={toggler} /> : null}

      {items.map((item, idx) => (
        <SwiperSlide key={idx}>
          <div className="col mb-3">
            <div className="card card-flush shadow-none h-100">
              <span
                className="card-pinned"
                onClick={() => setToggler(!toggler)}
                onMouseOver={() => setImgs(item.imgsrc)}
                style={{ cursor: "pointer" }}
              >
                <img
                  className="card-img"
                  src={item.imgsrc[0]}
                  alt="Description_Image"
                />

                {item.is_new ? (
                  <div className="card-pinned-top-start">
                    <span className="badge bg-success">New</span>
                  </div>
                ) : null}

                <div className="card-pinned-bottom-end">
                  <span className="btn btn-light btn-xs btn-icon">
                    <i className="bi-images"></i>
                  </span>
                </div>
              </span>

              <a className="card-body" href={item.link}>
                {item.is_for_sale ? (
                  <span className="card-subtitle text-body">For sale</span>
                ) : null}

                <div className="row align-items-center mb-3">
                  <div className="col">
                    <h4 className="card-title text-inherit">{item.title}</h4>
                  </div>

                  <div className="col-auto">
                    <h3 className="card-title text-secondary">{item.price}</h3>
                  </div>
                </div>

                <div className="d-flex gap-1 mb-2" title={item.marks}>
                  <span>Opinions: </span>
                  {t_marks(item.marks).map((star, idx) => {
                    return star === "y" ? (
                      <img
                        key={idx}
                        src="./assets/img/svg/illustrations/star.svg"
                        alt="Review rating"
                        width="14"
                      />
                    ) : star === "h" ? (
                      <img
                        key={idx}
                        src="./assets/img/svg/illustrations/star-half.svg"
                        alt="Review rating"
                        width="14"
                      />
                    ) : (
                      <img
                        key={idx}
                        src="./assets/img/svg/illustrations/star-muted.svg"
                        alt="Review rating"
                        width="14"
                      />
                    );
                  })}
                  ({item.marks}/5)
                </div>
              </a>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  ) : items.length === 0 ? (
    <div className="mx-auto d-block">
      <img src="assets/img/sticker70.png" alt="img" />
    </div>
  ) : (
    items.map((item, idx) => (
      <div key={idx}>
        <div className="col mb-3">
          <div className="card card-flush shadow h-100">
            <span className="card-pinned" style={{ cursor: "pointer" }}>
              <img
                className="card-img"
                src={item.logo}
                alt="Description_Image"
              />

              {item.is_new ? (
                <div className="card-pinned-top-start">
                  <span className="badge bg-success">New</span>
                </div>
              ) : null}
              {item.user_uuid ? null : (
                <div className="card-pinned-bottom-end">
                  <span className="btn btn-light btn-xs btn-icon">
                    <i className="bi-images"></i>
                  </span>
                </div>
              )}
            </span>

            {/* <ImageViewer sources={imgs} toggler={toggler} /> */}

            <a className="card-body" href={`/company-details/${btoa(item.id)}`}>
              {item.is_for_sale ? (
                <span className="card-subtitle text-body">For sale</span>
              ) : null}

              <div className="row align-items-center mb-3">
                <div className="col">
                  <h4 className="card-title text-inherit">{item.name}</h4>
                </div>

                <div className="col-auto">
                  <h3 className="card-title text-secondary">{item.type}</h3>
                </div>
              </div>

              {item.marks ? (
                <div className="d-flex gap-1 mb-2" title={item.marks}>
                  <span>Opinions: </span>
                  {t_marks(item.marks).map((star, idx) => {
                    return star === "y" ? (
                      <img
                        key={idx}
                        src="./assets/img/svg/illustrations/star.svg"
                        alt="Review rating"
                        width="14"
                      />
                    ) : star === "h" ? (
                      <img
                        key={idx}
                        src="./assets/img/svg/illustrations/star-half.svg"
                        alt="Review rating"
                        width="14"
                      />
                    ) : (
                      <img
                        key={idx}
                        src="./assets/img/svg/illustrations/star-muted.svg"
                        alt="Review rating"
                        width="14"
                      />
                    );
                  })}
                  ({item.marks}/5)
                </div>
              ) : null}

              {item.user_uuid ? <div>s</div> : null}
            </a>
          </div>
        </div>
      </div>
    ))
  );
};

export default ItemList;
